import React from 'react';
import { cn } from './utils/cn';
import { CardPair } from './PlayingCard';

/**
 * Нижняя рука игрока как в poker-table-ui (подпись комбинации + CardPair lg).
 */
export function PlayerHandStrip({
  cards,
  handName,
  faceDown = false,
  faceDownByIndex,
  cardKeys,
  slotRefs,
  showCardByIndex,
  /** Индекс карты в массиве `cards`. */
  onCardClick,
  getSlotClassName,
  className,
}) {
  if (!cards || cards.length === 0) return null;

  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      {handName ? (
        <div className="rounded-full border border-neon-gold/30 bg-black/50 px-3 py-1 backdrop-blur-sm">
          <span className="text-xs font-medium text-neon-gold">{handName}</span>
        </div>
      ) : null}
      <CardPair
        cards={cards}
        faceDown={faceDownByIndex ? false : faceDown}
        faceDownByIndex={faceDownByIndex}
        cardKeys={cardKeys}
        slotRefs={slotRefs}
        showCardByIndex={showCardByIndex}
        onSlotClick={onCardClick}
        getSlotClassName={getSlotClassName}
        size="lg"
        className="[filter:drop-shadow(0_0_15px_rgba(0,255,255,0.4))]"
      />
    </div>
  );
}
